import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import template from './pagination-template.pug';

const { updateView } = helpers;


export class Pagination extends DeterministicView {
  initialize({
    i18n,
    currentPage = 1,
    pageSize = 10,
    totalCount = 0,
  }) {
    this.i18n = i18n;
    this.pageSize = pageSize;

    this.setState({
      currentPage,
      totalCount,
    });
  }

  events() {
    return {
      'click .previous-page-button': () => {
        this.goToPreviousPage();
      },
      'click .next-page-button': () => {
        this.goToNextPage();
      },
    };
  }

  get template() {
    return template;
  }

  getState() {
    const {
      currentPage,
      totalCount,
    } = this.model.attributes;

    return {
      currentPage,
      totalCount,
    };
  }

  goToPreviousPage() {
    let { currentPage } = this.getState();
    if (currentPage <= 1) {
      return;
    }
    currentPage -= 1;

    updateView(this, {
      currentPage,
    });
    this.trigger('pageChanged', currentPage);
  }

  goToNextPage() {
    let { currentPage, totalCount } = this.getState(); // eslint-disable-line
    if (totalCount && (currentPage * this.pageSize) >= totalCount) {
      return;
    }

    currentPage += 1;

    updateView(this, {
      currentPage,
    });
    this.trigger('pageChanged', currentPage);
  }
}
